import React, { Component } from "react";
import commStyles from "../../common/styles";
import { connect } from "react-redux";
import { Container } from "../../common/components/Container";
import { Table } from "../../common/components/Table";
import { Model } from "../../common/components/Model";
import { ReactSelect } from "../../common/components/ReactSelect";
import apiCall from "../../common/utils/apiCall";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "../../common/styles/styles.css";
import moment from "moment";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Upload from "../../common/utils/upload";
import { PleaseWait } from "../../common/components/PleaseWait";
import downloadCsv from "../../common/utils/downloadCsv";
import Switch from "@mui/material/Switch";

const {
  Form,
  FormRow,
  FormColumn,
  FormInput,
  FormInputLabel,
  ButtonWrapper,
  ButtonSecondary,
  ButtonSuccess,
  SubHeading,
  StyledDatePicker,
} = commStyles;

const columns = [
  { id: "number", label: "number", minWidth: "10%" },
  { id: "sumOne", label: "sum one", minWidth: "10%" },
  { id: "sumTwo", label: "sum two", minWidth: "10%" },
  { id: "price", label: "price", minWidth: "10%" },
  { id: "status", label: "sold / unsold", minWidth: "10%" },
  { id: "categoryName", label: "Number Category", minWidth: "10%" },
  { id: "format", label: "Number Format", minWidth: "10%" },
  { id: "isAvailableForPrebooking", label: "Pre-Booking", minWidth: "10%" },
  { id: "prebookingAvailabilityDate", label: "Available From", minWidth: "10%" },
  { id: "createdAt", label: "created on", minWidth: "10%" },
  { id: "updatedAt", label: "updated on", minWidth: "10%" },
  { id: "operationEditDelete", label: "Edit / Delete", minWidth: "10%" },
];

let mountLimit = 1;
let filterHeight = document.getElementById("filterDiv")
  ? `${document.getElementById("filterDiv").offsetHeight}px`
  : "10vh";

class Numbers extends Component {
  constructor(props) {
    super(props);
    this.editModel = this.editModel.bind(this);
    this.state = {
      numbersData: [],
      totalSize: 0,
      rowsPerPage: 20,
      filterOptionsLimit: 20,
      editModelOpen: false,
      deleteModelOpen: false,
      createModelOpen: false,
      numbersFilterInput: "",
      priceFilterInput: "",
      soldUnsoldFilterInput: "",
      soldUnsoldEditInput: "",
      categoryFilterInput: "",
      categoryEditInput: "",
      categoryCreateInput: "",
      badgeEditInput: "",
      badgeCreateInput: "",
      numbersFilterOptions: [],
      priceFilterOptions: [],
      soldUnsoldFilterOptions: [],
      soldUnsoldEditOptions: [],
      categoryFilterOptions: [],
      categoryEditOptions: [],
      categoryCreateOptions: [],
      badgeEditOptions: [],
      badgeCreateOptions: [],
      numbersFilterLoading: false,
      priceFilterLoading: false,
      soldUnsoldFilterLoading: false,
      categoryFilterLoading: false,
      categoryEditLoading: false,
      categoryCreateLoading: false,
      badgeEditLoading: false,
      badgeCreateLoading: false,
      filterData: {},
      editData: {
        price: "",
        buyerId: "",
      },
      deleteData: {
        number: "",
      },
      createData: {},
      createToggleSelector: "singleCreate",
      uploadResults: {},
      editInfo: {},
      pleaseWaitLoading: false,
      pleaseWaitHeader: null,
      stats: { available: 0, sold: 0, prebooking: 0 },
      filtersOpen: true,
      dateRange: [null, null],
      bulkCategoryInput: "",
      bulkDiscountInput: "",
      exporting: false,
      bulkUpdating: false,
    };
  }

  async componentDidMount() {
    if (mountLimit == 1) {
      mountLimit++;
      try {
        const { result } = await apiCall("REACT_APP_GET_NUMBERS", "POST", {
          limit: this.state.rowsPerPage,
          skip: 0,
        });
        if (result && result["success"] && result["status"]) {
          let modifyData = await this.modifyApiData(result.status);
          this.setState({
            numbersData: modifyData,
            totalSize: await result.totalSize,
          });
          await this.fetchStats({});
          toast.success(result.msg);
        }
      } catch (error) {
        console.log("Numbers componentDidMount Error ::", error);
      }
      setTimeout(() => {
        mountLimit--;
      }, 500);
    }
  }

  async modifyApiData(rawDataArray) {
    return await rawDataArray.map((data) => {
      if (data.status == 1) {
        data.status = "sold";
      }
      if (data.status == 2) {
        data.status = "unsold";
      }
      // Normalize prebooking flag robustly (accept 1/"1"/true/"true")
      const rawPrebook = data.isAvailableForPrebooking;
      const isPrebook = rawPrebook === 1 || rawPrebook === true || rawPrebook === "1" || rawPrebook === "true";
      data.isAvailableForPrebooking = isPrebook;
      if (isPrebook && data.prebookingAvailabilityDate) {
        data.prebookingAvailabilityDate = moment(data.prebookingAvailabilityDate).format("DD MMM YYYY");
      }
      data.createdAt = new Date(data.createdAt).toLocaleString();
      data.createdAt = moment(data.createdAt).format("DD MMM YYYY, hh:mm A");
      data.updatedAt = new Date(data.updatedAt).toLocaleString();
      data.updatedAt = moment(data.updatedAt).format("DD MMM YYYY, hh:mm A");
      data["operationEditDelete"] = data.id;

      return data;
    });
  }

  editModel(data) {
    let editData = this.state.editData;
    editData["id"] = data.id;
    editData["price"] = [data.price];
    editData["categoryName"] = [data.categoryName];
    editData["buyerId"] = data.buyerId;
    editData["format"] = [data.format];
    editData["discount"] = [data.discount];
    editData["badgeName"] = [data.badgeName];
    editData["isAvailableForPrebooking"] = data.isAvailableForPrebooking === true;
    // Normalize to datetime-local compatible value if present
    if (data.prebookingAvailabilityDate) {
      const normalized = moment(
        data.prebookingAvailabilityDate,
        ["YYYY-MM-DDTHH:mm", "YYYY-MM-DDTHH:mm:ss", "DD MMM YYYY", "DD MMM YYYY, hh:mm A"],
        true
      ).isValid()
        ? moment(
            data.prebookingAvailabilityDate,
            ["YYYY-MM-DDTHH:mm", "YYYY-MM-DDTHH:mm:ss", "DD MMM YYYY", "DD MMM YYYY, hh:mm A"],
            true
          ).format("YYYY-MM-DDTHH:mm")
        : null;
      editData["prebookingAvailabilityDate"] = normalized;
    } else {
      editData["prebookingAvailabilityDate"] = null;
    }
    if (data.status == "deleted") {
      editData["status"] = 0;
    } else if (data.status == "sold") {
      editData["status"] = 1;
    } else if (data.status == "unsold") {
      editData["status"] = 2;
    }
    console.log("Edit Data:", editData);
    this.setState({ editData, editModelOpen: true, editInfo: data });
  }
  deleteEntry = (data) => {
    let deleteData = this.state.deleteData;
    deleteData["number"] = data.number;
    this.setState({ deleteData, deleteModelOpen: true });
  };

  formatData = async (data, value, label) => {
    return await data.map((eachData) => {
      let obj = {};
      obj["value"] = eachData[value];
      obj["label"] = eachData[label];
      return obj;
    });
  };
  handleChange = async (event, state, stateEdit, stateCreate) => {
    if (!Array.isArray(event)) {
      event = [event];
    }

    if (stateEdit) {
      let editData = this.state.editData;
      editData[stateEdit] = [];
      await event.forEach((data) => editData[stateEdit].push(data.value));
      this.setState({ editData });
    } else if (stateCreate) {
      let createData = this.state.createData;
      createData[stateCreate] = "";
      await event.forEach((data) => (createData[stateCreate] = data.value));
      this.setState({ createData });
    } else {
      let filterData = this.state.filterData;
      filterData[state] = [];
      await event.forEach((data) => filterData[state].push(data.value));
      this.setState({ filterData });
    }
  };

  handleNumbersInputChange = async (numbersFilterInput, { action }) => {
    this.setState({ numbersFilterLoading: true });
    let input;
    let numbersFilterOptions = [];
    if (action === "set-value") {
      input = this.state.numbersFilterInput;
    } else {
      input = numbersFilterInput;
      this.setState({ numbersFilterInput });
    }
    if (input.split("").length >= 0) {
      const { result } = await apiCall("REACT_APP_GET_NUMBERS", "POST", {
        textToSearch: input,
        limit: this.state.filterOptionsLimit,
      });
      if (result && result.success) {
        numbersFilterOptions = await this.formatData(
          result.status,
          "id",
          "number"
        );
      }
    }

    this.setState({ numbersFilterOptions, numbersFilterLoading: false });
  };
  handlePriceInputChange = async (priceFilterInput, { action }) => {
    this.setState({ priceFilterLoading: true });
    let input;
    let priceFilterOptions = [];
    if (action === "set-value") {
      input = this.state.priceFilterInput;
    } else {
      input = priceFilterInput;
      this.setState({ priceFilterInput });
    }
    if (input.split("").length >= 0) {
      const { result } = await apiCall("REACT_APP_GET_NUMBERS", "POST", {
        textToSearch: input,
        limit: this.state.filterOptionsLimit,
      });
      if (result && result.success) {
        priceFilterOptions = await this.formatData(
          result.status,
          "price",
          "price"
        );
      }
    }

    this.setState({ priceFilterOptions, priceFilterLoading: false });
  };
  handleSoldUnsoldInputChange = async (soldUnsoldFilterInput, { action }) => {
    this.setState({ soldUnsoldFilterLoading: true });
    let input;
    let soldUnsoldFilterOptions = [
      { value: 1, label: "sold" },
      { value: 2, label: "unsold" },
    ];
    if (action === "set-value") {
      input = this.state.soldUnsoldFilterInput;
    } else {
      input = soldUnsoldFilterInput;
      this.setState({ soldUnsoldFilterInput });
    }

    this.setState({ soldUnsoldFilterOptions, soldUnsoldFilterLoading: false });
  };
  handleSoldUnsoldEditInputChange = async (soldUnsoldEditInput, { action }) => {
    let input;
    let soldUnsoldEditOptions = [
      { value: 1, label: "sold" },
      { value: 2, label: "unsold" },
    ];
    if (action === "set-value") {
      input = this.state.soldUnsoldEditInput;
    } else {
      input = soldUnsoldEditInput;
      this.setState({ soldUnsoldEditInput });
    }

    this.setState({ soldUnsoldEditOptions });
  };
  handleCategoryInputChange = async (categoryFilterInput, { action }) => {
    this.setState({ categoryFilterLoading: true });
    let input;
    let categoryFilterOptions = [];
    if (action === "set-value") {
      input = this.state.categoryFilterInput;
    } else {
      input = categoryFilterInput;
      this.setState({ categoryFilterInput });
    }
    if (input.split("").length >= 0) {
      const { result } = await apiCall("REACT_APP_GET_CATEGORY", "POST", {
        textToSearch: input,
        limit: this.state.filterOptionsLimit,
      });
      if (result && result.success) {
        categoryFilterOptions = await this.formatData(
          result.status,
          "categoryName",
          "categoryName"
        );
      }
    }

    this.setState({ categoryFilterOptions, categoryFilterLoading: false });
  };
  handleCategoryEditInputChange = async (categoryEditInput, { action }) => {
    this.setState({ categoryEditLoading: true });
    let input;
    let categoryEditOptions = [];
    if (action === "set-value") {
      input = this.state.categoryEditInput;
    } else {
      input = categoryEditInput;
      this.setState({ categoryEditInput });
    }
    if (input.split("").length >= 0) {
      const { result } = await apiCall("REACT_APP_GET_CATEGORY", "POST", {
        textToSearch: input,
        limit: this.state.filterOptionsLimit,
      });
      if (result && result.success) {
        categoryEditOptions = await this.formatData(
          result.status,
          "categoryName",
          "categoryName"
        );
      }
    }

    this.setState({ categoryEditOptions, categoryEditLoading: false });
  };

  handleBadgeEditInputChange = async (badgeEditInput, { action }) => {
    this.setState({ badgeEditLoading: true });
    let input;
    let badgeEditOptions = [];
    if (action === "set-value") {
      input = this.state.badgeEditInput;
    } else {
      input = badgeEditInput;
      this.setState({ badgeEditInput });
    }
    if (input.split("").length >= 0) {
      const { result } = await apiCall("REACT_APP_GET_BADGE", "POST", {
        textToSearch: input,
        limit: this.state.filterOptionsLimit,
      });
      if (result && result.success) {
        badgeEditOptions = await this.formatData(
          result.status,
          "badgeName",
          "badgeName"
        );
      }
    }

    this.setState({ badgeEditOptions, badgeEditLoading: false });
  };

  handleCategoryCreateInputChange = async (categoryCreateInput, { action }) => {
    this.setState({ categoryCreateLoading: true });
    let input;
    let categoryCreateOptions = [];
    if (action === "set-value") {
      input = this.state.categoryCreateInput;
    } else {
      input = categoryCreateInput;
      this.setState({ categoryCreateInput });
    }
    if (input.split("").length >= 0) {
      const { result } = await apiCall("REACT_APP_GET_CATEGORY", "POST", {
        textToSearch: input,
        limit: this.state.filterOptionsLimit,
      });
      if (result && result.success) {
        categoryCreateOptions = await this.formatData(
          result.status,
          "categoryName",
          "categoryName"
        );
      }
    }

    this.setState({ categoryCreateOptions, categoryCreateLoading: false });
  };

  handleBadgeCreateInputChange = async (badgeCreateInput, { action }) => {
    this.setState({ badgeCreateLoading: true });
    let input;
    let badgeCreateOptions = [];
    if (action === "set-value") {
      input = this.state.badgeCreateInput;
    } else {
      input = badgeCreateInput;
      this.setState({ badgeCreateInput });
    }
    if (input.split("").length >= 0) {
      const { result } = await apiCall("REACT_APP_GET_BADGE", "POST", {
        textToSearch: input,
        limit: this.state.filterOptionsLimit,
      });
      if (result && result.success) {
        badgeCreateOptions = await this.formatData(
          result.status,
          "badgeName",
          "badgeName"
        );
      }
    }

    this.setState({ badgeCreateOptions, badgeCreateLoading: false });
  };

  submitFilter = async (filterData) => {
    Object.keys(filterData).forEach((data) => {
      if (
        filterData[data] == [] ||
        filterData[data] == {} ||
        filterData[data] == ""
      ) {
        delete filterData[data];
      }
    });

    // Dates are already normalized to ISO in the DatePicker onChange handler.
    // Avoid re-normalizing here to prevent invalid date strings.
    const normalized = { ...filterData };
    if (!(normalized.startDate && normalized.endDate)) {
      delete normalized.startDate;
      delete normalized.endDate;
    }

    normalized["skip"] = 0;
    normalized["limit"] = this.state.rowsPerPage || 20;
    const { result } = await apiCall(
      "REACT_APP_GET_NUMBERS",
      "POST",
      normalized
    );
    if (result && result["success"] && result["status"]) {
      let modifyData = await this.modifyApiData(result.status);
      this.setState({
        numbersData: modifyData,
        totalSize: await result.totalSize,
      });
      // refresh stats with current filters (without pagination)
      await this.fetchStats({ ...normalized, skip: undefined, limit: undefined });
      toast.success(result.msg);
    }
  };
  submitEditForm = async (editData) => {
    console.log("Submitting Edit Data:", editData);
    // Build payload and normalize prebooking fields
    const payload = { ...editData };
    payload.isAvailableForPrebooking = editData.isAvailableForPrebooking === true;
    if (payload.isAvailableForPrebooking === false) {
      delete payload.prebookingAvailabilityDate;
    } else if (payload.isAvailableForPrebooking === true) {
      if (!payload.prebookingAvailabilityDate) {
        toast.error("Please select 'Available From' when enabling pre-booking");
        return;
      }
    }

    Object.keys(payload).forEach((key) => {
      const val = payload[key];
      const isEmptyArray = Array.isArray(val) && val.length === 0;
      const isEmptyObject = val && typeof val === "object" && !Array.isArray(val) && Object.keys(val).length === 0;
      const isEmptyString = val === "";
      const isNull = val === null;
      if (isEmptyArray || isEmptyObject || isEmptyString || isNull) {
        delete payload[key];
      }
    });
    if (Object.keys(payload).length == 0) {
      return;
    }

    if (payload.price && Array.isArray(payload.price)) {
      payload.price = payload.price[0];
    }
    if (payload.categoryName && Array.isArray(payload.categoryName)) {
      payload.categoryName = payload.categoryName[0];
    }
    if (payload.format && Array.isArray(payload.format)) {
      payload.format = payload.format[0];
    }
    if (payload.status && Array.isArray(payload.status)) {
      payload.status = payload.status[0];
    }
    if (payload.badgeName && Array.isArray(payload.badgeName)) {
      payload.badgeName = payload.badgeName[0];
    }

    console.log("Processed Edit Data:", payload);

    const { result } = await apiCall(
      "REACT_APP_UPDATE_NUMBER",
      "POST",
      payload
    );
    console.log("Update Response:", result);

    if (result && result["success"] && result["status"]) {
      this.setState({ editModelOpen: false });
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  };
  submitDeleteForm = async (deleteData) => {
    Object.keys(deleteData).forEach((data) => {
      if (
        deleteData[data] == [] ||
        deleteData[data] == {} ||
        deleteData[data] == ""
      ) {
        delete deleteData[data];
      }
    });
    if (Object.keys(deleteData).length == 0) {
      return;
    }
    const { result } = await apiCall(
      "REACT_APP_DELETE_NUMBER",
      "POST",
      deleteData
    );
    if (result && result["success"] && result["status"]) {
      this.setState({ deleteModelOpen: false });
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  };
  submitCreateForm = async (createData) => {
    this.setState({
      pleaseWaitLoading: true,
      pleaseWaitHeader: "Data is Uploading... (Est. 2 to 3 mins)",
    });
    if (this.state.createToggleSelector === "bulkCreate") {
      let bulkData = this.state.uploadResults;
      const { result } = await apiCall("REACT_APP_CREATE_BULK_NUMBER", "POST", {
        data: bulkData.data,
        fileName: bulkData.path,
        reqStamp: new Date().getTime(),
      });
      if (result && result["success"] && result["status"]) {
        this.setState({ createModelOpen: false });
        this.submitFilter(this.state.filterData);
        toast.success(result.msg);
      } else if (result && result.msg && result.msg == "PARAMETER_ISSUE") {
        // na
      } else {
        await downloadCsv({
          arrayOfObj: result["err"],
          fileName: result["fileName"],
        });
        this.setState({ createModelOpen: false });
        this.submitFilter(this.state.filterData);
      }
    } else {
      Object.keys(createData).forEach((data) => {
        if (
          createData[data] == [] ||
          createData[data] == {} ||
          createData[data] == ""
        ) {
          delete createData[data];
        }
      });
      if (Object.keys(createData).length == 0) {
        this.setState({ pleaseWaitLoading: false, pleaseWaitHeader: null });
        return;
      }
      console.log(createData);
      const { result } = await apiCall(
        "REACT_APP_CREATE_NUMBER",
        "POST",
        createData
      );
      if (result && result["success"] && result["status"]) {
        this.setState({ createModelOpen: false });
        this.submitFilter(this.state.filterData);
        toast.success(result.msg);
      }
    }
    this.setState({ pleaseWaitLoading: false, pleaseWaitHeader: null });
  };
  handleChangePage = async (chnagedPage, rowsPerPage) => {
    let filterData = this.state.filterData;
    let skippedEmptyArrayOfObj = [];
    Object.keys(filterData).forEach((data) => {
      if (
        filterData[data] == [] ||
        filterData[data] == {} ||
        filterData[data] == ""
      ) {
        delete filterData[data];
      }
    });
    filterData["skip"] = chnagedPage * rowsPerPage || 0;
    filterData["limit"] = rowsPerPage || 20;
    for (let i = 0; i < filterData["skip"]; i++) {
      skippedEmptyArrayOfObj.push({});
    }
    const { result } = await apiCall(
      "REACT_APP_GET_NUMBERS",
      "POST",
      filterData
    );
    if (result && result["success"] && result["status"]) {
      let modifyData = await this.modifyApiData(result.status);
      this.setState({
        numbersData: [...skippedEmptyArrayOfObj, ...modifyData],
        rowsPerPage: rowsPerPage,
        totalSize: await result.totalSize,
      });
      return true;
    }
    return false;
  };

  handleCreateToggleChnage = (event, createToggleSelector) => {
    if (!createToggleSelector) {
      this.setState({ createToggleSelector: "singleCreate" });
    } else {
      this.setState({ createToggleSelector });
    }
  };

  uploadResults = (result) => {
    this.setState({ uploadResults: result });
  };

  clearFilters = async () => {
    const cleared = {
      // keep pagination external
    };
    this.setState({
      filterData: cleared,
      numbersFilterInput: "",
      priceFilterInput: "",
      soldUnsoldFilterInput: "",
      categoryFilterInput: "",
      dateRange: [null, null],
    });
    // reload with empty filters
    await this.submitFilter({});
  };

  renderActiveFilterChips() {
    const fd = this.state.filterData || {};
    const chips = [];
    const pushChip = (label, value, onClear) => (
      <span
        key={`${label}-${value}`}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          padding: "6px 10px",
          borderRadius: "16px",
          background: "#f1f3f5",
          color: "#000040",
          fontSize: "12px",
          fontWeight: 600,
          border: "1px solid #e9ecef",
        }}
      >
        {label}: {value}
        <CloseIcon
          onClick={onClear}
          sx={{ width: "14px", height: "14px", cursor: "pointer" }}
        />
      </span>
    );
    if (fd.id && fd.id.length) chips.push(pushChip("IDs", fd.id.length, () => this.setState({ filterData: { ...fd, id: [] } })));
    if (fd.price && fd.price.length) chips.push(pushChip("Price", fd.price.length, () => this.setState({ filterData: { ...fd, price: [] } })));
    if (fd.status && fd.status.length) chips.push(pushChip("Status", fd.status.join(","), () => this.setState({ filterData: { ...fd, status: [] } })));
    if (fd.categoryName && fd.categoryName.length) chips.push(pushChip("Category", fd.categoryName.length, () => this.setState({ filterData: { ...fd, categoryName: [] } })));
    if (fd.startDate && fd.endDate)
      chips.push(
        pushChip(
          "Created",
          `${moment(fd.startDate).format("DD MMM YY")} → ${moment(fd.endDate).format("DD MMM YY")}`,
          () => this.setState({ filterData: { ...fd, startDate: undefined, endDate: undefined } })
        )
      );
    if (!chips.length) return null;
    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", margin: "8px 0 0 0" }}>{chips}</div>
    );
  }

  // Fetch aggregate stats using dedicated stats endpoint
  fetchStats = async (baseFilters) => {
    try {
      const payload = { ...baseFilters };
      // Remove pagination from payload if present
      delete payload.skip;
      delete payload.limit;
      // Try dedicated stats endpoint first
      let statsResp = await apiCall("REACT_APP_GET_NUMBERS_STATS", "POST", payload, false);
      if (!statsResp || !statsResp.result || statsResp.result.success === false) {
        // Fallback: use main endpoint with statsOnly flag
        statsResp = await apiCall("REACT_APP_GET_NUMBERS", "POST", { ...payload, statsOnly: true }, false);
      }
      const stats = statsResp?.result?.status || { available: 0, sold: 0, prebooking: 0 };
      this.setState({ stats });
    } catch (e) {
      console.log("fetchStats error", e);
    }
  };

  render() {
    return (
      <React.Fragment>
        <Container headerName="Numbers Manager" navPosition="1">
          {/* Header Section with Total Count */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px",
              backgroundColor: "#000040",
              color: "white",
              borderRadius: "8px",
              margin: "16px 0",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
            }}
          >
            <div>
              <h2 style={{ margin: "0 0 8px 0", fontSize: "24px", fontWeight: "600" }}>
                Numbers Manager
              </h2>
              <p style={{ margin: "0", fontSize: "14px", opacity: "0.9" }}>
                Manage all numbers in the system
              </p>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: "32px", fontWeight: "bold", color: "#ff0000" }}>
                {this.state.totalSize || 0}
              </div>
              <div style={{ fontSize: "14px", opacity: "0.9" }}>Total Numbers</div>
            </div>
          </div>
          
          {/* Quick Stats Row */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "16px",
              margin: "0 0 20px 0"
            }}
          >
            <div
              style={{
                padding: "16px",
                background: "linear-gradient(180deg, #ffffff 0%, #f9fbff 100%)",
                borderRadius: "10px",
                border: "1px solid #e9ecef",
                boxShadow: "0 2px 6px rgba(0,0,64,0.06)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "12px", letterSpacing: "0.4px", color: "#6c757d", fontWeight: 700, textTransform: "uppercase", marginBottom: "6px" }}>Available</div>
              <div style={{ fontSize: "28px", fontWeight: "800", color: "#000040", lineHeight: 1 }}>
                {this.state.stats.available}
              </div>
              <div style={{ fontSize: "11px", color: "#8a94a6", fontWeight: 600, marginTop: "4px" }}>items</div>
            </div>
            
            <div
              style={{
                padding: "16px",
                background: "linear-gradient(180deg, #ffffff 0%, #fff9f9 100%)",
                borderRadius: "10px",
                border: "1px solid #ffe3e3",
                boxShadow: "0 2px 6px rgba(255,0,0,0.06)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "12px", letterSpacing: "0.4px", color: "#d63333", fontWeight: 700, textTransform: "uppercase", marginBottom: "6px" }}>Sold</div>
              <div style={{ fontSize: "28px", fontWeight: "800", color: "#ff0000", lineHeight: 1 }}>
                {this.state.stats.sold}
              </div>
              <div style={{ fontSize: "11px", color: "#c92a2a", fontWeight: 600, marginTop: "4px" }}>items</div>
            </div>
            
            <div
              style={{
                padding: "16px",
                background: "linear-gradient(180deg, #ffffff 0%, #f9fbff 100%)",
                borderRadius: "10px",
                border: "1px solid #e9ecef",
                boxShadow: "0 2px 6px rgba(0,0,64,0.06)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "12px", letterSpacing: "0.4px", color: "#6c757d", fontWeight: 700, textTransform: "uppercase", marginBottom: "6px" }}>Pre-Booking</div>
              <div style={{ fontSize: "28px", fontWeight: "800", color: "#000040", lineHeight: 1 }}>
                {this.state.stats.prebooking}
              </div>
              <div style={{ fontSize: "11px", color: "#8a94a6", fontWeight: 600, marginTop: "4px" }}>items</div>
            </div>
            
            <div
              style={{
                padding: "16px",
                background: "linear-gradient(180deg, #ffffff 0%, #f9fbff 100%)",
                borderRadius: "10px",
                border: "1px solid #e9ecef",
                boxShadow: "0 2px 6px rgba(0,0,64,0.06)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "12px", letterSpacing: "0.4px", color: "#6c757d", fontWeight: 700, textTransform: "uppercase", marginBottom: "6px" }}>Discounted</div>
              <div style={{ fontSize: "28px", fontWeight: "800", color: "#000040", lineHeight: 1 }}>
                {this.state.stats.discounted || 0}
              </div>
              <div style={{ fontSize: "11px", color: "#8a94a6", fontWeight: 600, marginTop: "4px" }}>items</div>
            </div>
          </div>
          
          {/* Filter Section */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              padding: "20px",
              margin: "0 0 20px 0",
              border: "1px solid #e9ecef"
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ margin: 0, color: "#000040", fontSize: "18px", fontWeight: 600 }}>Filters</h3>
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center", justifyContent: "flex-end" }}>
                <ButtonSuccess
                  style={{ height: "34px", padding: "8px 14px", backgroundColor: "#ff0000", fontSize: "12px", minWidth: "120px", display: "inline-flex", alignItems: "center", justifyContent: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                  onClick={() => this.submitFilter({ ...this.state.filterData })}
                >
                  <FilterAltIcon sx={{ width: "14px" }} /> Apply
                </ButtonSuccess>
                <ButtonSuccess
                  style={{ height: "34px", padding: "8px 14px", backgroundColor: "#000040", fontSize: "12px", minWidth: "120px", display: "inline-flex", alignItems: "center", justifyContent: "center", whiteSpace: "nowrap" }}
                  onClick={this.clearFilters}
                >
                  Reset
                </ButtonSuccess>
                <span
                  onClick={() => this.setState({ filtersOpen: !this.state.filtersOpen })}
                  style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", color: "#000040", fontWeight: 600, padding: "8px 10px" }}
                >
                  {this.state.filtersOpen ? "Hide" : "Show"} {this.state.filtersOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </span>
              </div>
            </div>

            {this.renderActiveFilterChips()}

            {this.state.filtersOpen ? (<div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "20px"
            }}>
              <div>
                <label style={{ 
                  color: "#000040", 
                  fontWeight: "600", 
                  fontSize: "14px",
                  marginBottom: "8px",
                  display: "block"
                }}>
                  Numbers
                </label>
                <ReactSelect
                  placeholder={"Select Numbers"}
                  inputValue={this.state.numbersFilterInput}
                  onInputChange={this.handleNumbersInputChange}
                  options={this.state.numbersFilterOptions}
                  stateFilterName={"id"}
                  onChange={this.handleChange}
                  isLoading={this.state.numbersFilterLoading}
                  isMulti={true}
                />
              </div>
              
              <div>
                <label style={{ 
                  color: "#000040", 
                  fontWeight: "600", 
                  fontSize: "14px",
                  marginBottom: "8px",
                  display: "block"
                }}>
                  Price
                </label>
                <ReactSelect
                  placeholder={"Select Price"}
                  inputValue={this.state.priceFilterInput}
                  onInputChange={this.handlePriceInputChange}
                  options={this.state.priceFilterOptions}
                  stateFilterName={"price"}
                  onChange={this.handleChange}
                  isLoading={this.state.priceFilterLoading}
                  isMulti={true}
                />
              </div>
              
              <div>
                <label style={{ 
                  color: "#000040", 
                  fontWeight: "600", 
                  fontSize: "14px",
                  marginBottom: "8px",
                  display: "block"
                }}>
                  Status
                </label>
                <ReactSelect
                  placeholder={"Select Status"}
                  inputValue={this.state.soldUnsoldFilterInput}
                  onInputChange={this.handleSoldUnsoldInputChange}
                  options={this.state.soldUnsoldFilterOptions}
                  stateFilterName={"status"}
                  onChange={this.handleChange}
                  isLoading={this.state.soldUnsoldFilterLoading}
                  isMulti={true}
                />
              </div>
              
              <div>
                <label style={{ 
                  color: "#000040", 
                  fontWeight: "600", 
                  fontSize: "14px",
                  marginBottom: "8px",
                  display: "block"
                }}>
                  Category
                </label>
                <ReactSelect
                  placeholder={"Search Category"}
                  inputValue={this.state.categoryFilterInput}
                  onInputChange={this.handleCategoryInputChange}
                  options={this.state.categoryFilterOptions}
                  stateFilterName={"categoryName"}
                  onChange={this.handleChange}
                  isLoading={this.state.categoryFilterLoading}
                  isMulti={true}
                />
              </div>
 
              <div>
                <label style={{ 
                  color: "#000040", 
                  fontWeight: "600", 
                  fontSize: "14px",
                  marginBottom: "8px",
                  display: "block"
                }}>
                  Created Date Range
                </label>
                <StyledDatePicker
                  selectsRange
                  startDate={this.state.dateRange[0]}
                  endDate={this.state.dateRange[1]}
                  onChange={(update) => {
                    const [start, end] = update;
                    const next = { ...this.state.filterData };
                    if (start && end) {
                      next.startDate = new Date(start).toISOString();
                      const endOfDay = new Date(end);
                      endOfDay.setHours(23,59,59,999);
                      next.endDate = endOfDay.toISOString();
                    } else {
                      delete next.startDate;
                      delete next.endDate;
                    }
                    this.setState({ dateRange: update, filterData: next });
                  }}
                  isClearable
                  placeholderText="Select date range"
                  dateFormat="dd MMM yyyy"
                  withPortal
                  popperPlacement="bottom-start"
                />
            </div>
            </div>) : null}
          </div>

          {/* Bulk Discount Panel */}
          <div
            style={{
              background: "#ffffff",
              border: "1px solid #e9ecef",
              borderRadius: "10px",
              padding: "16px",
              margin: "0 0 20px 0",
              boxShadow: "0 2px 6px rgba(0,0,0,0.04)"
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
              <div>
                <div style={{ fontSize: "16px", fontWeight: 700, color: "#000040" }}>Bulk Discount by Category</div>
                <div style={{ fontSize: "12px", color: "#6c757d" }}>Apply or clear a discount across all unsold items in a category.</div>
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "minmax(200px, 360px) 160px auto", gap: "12px", alignItems: "center" }}>
              <ReactSelect
                placeholder={"Select Category"}
                inputValue={this.state.categoryFilterInput}
                onInputChange={this.handleCategoryInputChange}
                options={this.state.categoryFilterOptions}
                onChange={(e) => {
                  const value = Array.isArray(e) ? (e[0]?.value || "") : (e?.value || "");
                  this.setState({ bulkCategoryInput: value, categoryFilterInput: "" });
                }}
                isLoading={this.state.categoryFilterLoading}
                isMulti={false}
              />
              <input
                type="number"
                min={0}
                max={100}
                placeholder="Discount %"
                value={this.state.bulkDiscountInput}
                onChange={(e) => this.setState({ bulkDiscountInput: e.target.value })}
                style={{ height: "38px", padding: "8px 10px", border: "1px solid #ced4da", borderRadius: "6px", width: "160px" }}
              />
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                <ButtonSuccess
                  style={{ height: "38px", padding: "8px 14px", backgroundColor: this.state.bulkUpdating ? "#adb5bd" : "#ff0000", fontSize: "12px", minWidth: "120px", opacity: this.state.bulkUpdating ? 0.7 : 1, cursor: this.state.bulkUpdating ? "not-allowed" : "pointer" }}
                  onClick={async () => {
                    if (this.state.bulkUpdating) return;
                    const cat = this.state.bulkCategoryInput;
                    const disc = parseInt(this.state.bulkDiscountInput, 10);
                    if (!cat || isNaN(disc) || disc < 0 || disc > 100) {
                      toast.error("Select category and enter discount 0-100");
                      return;
                    }
                    try {
                      this.setState({ bulkUpdating: true });
                      const { result } = await apiCall("REACT_APP_BULK_DISCOUNT_BY_CATEGORY", "POST", { categoryName: cat, discount: disc });
                      if (result && result.success) {
                        toast.success(result.msg || "Bulk discount applied");
                        await this.submitFilter({ ...this.state.filterData });
                      } else {
                        toast.error(result?.msg || "Failed to apply bulk discount");
                      }
                    } finally {
                      this.setState({ bulkUpdating: false });
                    }
                  }}
                >
                  Apply Discount
                </ButtonSuccess>
                <ButtonSuccess
                  style={{ height: "38px", padding: "8px 14px", backgroundColor: this.state.bulkUpdating ? "#adb5bd" : "#000040", fontSize: "12px", minWidth: "120px", opacity: this.state.bulkUpdating ? 0.7 : 1, cursor: this.state.bulkUpdating ? "not-allowed" : "pointer" }}
                  onClick={async () => {
                    if (this.state.bulkUpdating) return;
                    const cat = this.state.bulkCategoryInput;
                    if (!cat) {
                      toast.error("Select category to clear discount");
                      return;
                    }
                    try {
                      this.setState({ bulkUpdating: true });
                      const { result } = await apiCall("REACT_APP_BULK_DISCOUNT_BY_CATEGORY", "POST", { categoryName: cat, discount: 0 });
                      if (result && result.success) {
                        toast.success(result.msg || "Bulk discount cleared");
                        await this.submitFilter({ ...this.state.filterData });
                      } else {
                        toast.error(result?.msg || "Failed to clear discount");
                      }
                    } finally {
                      this.setState({ bulkUpdating: false });
                    }
                  }}
                >
                  Clear Discount
                </ButtonSuccess>
              </div>
            </div>
          </div>
          
          {/* Action Buttons */}
          <div style={{
                display: "flex",
            justifyContent: "space-between",
            gap: "10px",
            margin: "0 0 20px 0"
          }}>
              <ButtonSuccess
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                  height: "40px",
                  padding: "8px 20px",
                  backgroundColor: "#ff0000",
                  fontSize: "14px"
                }}
                onClick={async () => {
                  if (this.state.exporting) return;
                  try {
                    this.setState({ exporting: true });
                    const base = { ...this.state.filterData };
                    delete base.skip; delete base.limit;
                    // First fetch minimal to get totalSize
                    const head = await apiCall("REACT_APP_GET_NUMBERS", "POST", { ...base, limit: 1, skip: 0 });
                    const totalSize = head?.result?.totalSize || 0;
                    if (!head || !head.result || head.result.success === false) {
                      toast.error(head?.result?.msg || "Failed to prepare export");
                      this.setState({ exporting: false });
                      return;
                    }
                    const batchSize = 1000;
                    let all = [];
                    for (let offset = 0; offset < totalSize; offset += batchSize) {
                      const resp = await apiCall("REACT_APP_GET_NUMBERS", "POST", { ...base, limit: batchSize, skip: offset }, false);
                      if (resp && resp.result && resp.result.success && Array.isArray(resp.result.status)) {
                        all = all.concat(resp.result.status);
                      } else {
                        break;
                      }
                    }
                    const rows = await this.modifyApiData(all);
                    downloadCsv({
                      arrayOfObj: rows,
                      fileName: `numbers-export-${new Date().toISOString().slice(0,10)}.csv`
                    });
                    toast.success(`Exported ${rows.length} numbers as CSV`);
                  } catch (e) {
                    toast.error(e.message || "Export failed");
                  } finally {
                    this.setState({ exporting: false });
                  }
                }}
              >
              Export CSV
              </ButtonSuccess>
              <ButtonSuccess
                style={{
                  display: "flex",
                  flexDirection: "row",
                gap: "8px",
                  alignItems: "center",
                height: "40px",
                padding: "8px 20px",
                backgroundColor: "#000040",
                fontSize: "14px"
                }}
                onClick={() => {
                  this.setState({ createData: {}, createModelOpen: true });
                }}
              >
              <AddCircleIcon sx={{ width: "18px" }} />
              Create Number
              </ButtonSuccess>
            </div>
          
          {/* Table Section */}
          <div style={{ 
            backgroundColor: "white", 
            borderRadius: "8px", 
            overflow: "hidden",
            border: "1px solid #e9ecef"
          }}>
          <Table
            columns={columns || []}
            dataValues={this.state.numbersData || []}
            totalSize={this.state.totalSize || 0}
            rowsPerPage={this.state.rowsPerPage}
            handleChangePage={this.handleChangePage}
            editModel={this.editModel}
            deleteEntry={this.deleteEntry}
          />
          </div>
        </Container>

        {/* EDIT MODEL */}
        <Model
          title={`Edit Number (${this.state.editInfo.number || ""})`}
          modelOpen={this.state.editModelOpen}
        >
          <Form>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "12px" }}>
              <div style={{ background: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: "8px", padding: "10px 12px", color: "#000040", fontWeight: 700, fontSize: "13px" }}>Pricing & Category</div>
              <div style={{ background: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: "8px", padding: "10px 12px", color: "#000040", fontWeight: 700, fontSize: "13px" }}>Status & Badges</div>
            </div>
            <FormRow
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                columnGap: "20px",
              }}
            >
              <FormColumn>
                <FormInputLabel>Price</FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  value={this.state.editData.price[0]}
                  placeholder="Price"
                  onChange={(e) => {
                    this.handleChange(e.target, "", "price");
                  }}
                ></FormInput>
                <FormInputLabel>Category</FormInputLabel>
                <ReactSelect
                  placeholder={"Search Category"}
                  inputValue={this.state.categoryEditInput}
                  onInputChange={this.handleCategoryEditInputChange}
                  options={this.state.categoryEditOptions}
                  value={
                    this.state.editData.categoryName
                      ? {
                          value: this.state.editData.categoryName[0],
                          label: this.state.editData.categoryName[0],
                        }
                      : false
                  }
                  stateEditName={"categoryName"}
                  onChange={(e) => {
                    this.handleChange(e, "", "categoryName");
                    this.setState({ categoryEditInput: "" });
                  }}
                  isLoading={this.state.categoryEditLoading}
                  isMulti={false}
                />
                <div style={{ marginTop: "14px" }}>
                  <FormInputLabel>Discount</FormInputLabel>
                </div>
                <FormInput
                  type="number"
                  required={true}
                  placeholder="Enter Discount"
                  min={0}
                  max={100}
                  value={this.state.editData.discount}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (value !== "") {
                      value = Number(value);

                      // Ensure the value is between 0 and 100
                      if (value < 0) value = 0;
                      if (value > 100) value = 100;
                    }
                    this.handleChange({ value }, "", "discount", "");
                  }}
                ></FormInput>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                  <FormInputLabel style={{ margin: 0 }}>Pre-Booking</FormInputLabel>
                  <Switch
                    checked={this.state.editData.isAvailableForPrebooking === true}
                    onChange={(e) => {
                      let editData = this.state.editData;
                      editData.isAvailableForPrebooking = e.target.checked;
                      if (!e.target.checked) {
                        editData.prebookingAvailabilityDate = null;
                      }
                      this.setState({ editData });
                    }}
                  />
                </div>
                {this.state.editData.isAvailableForPrebooking === true && (
                  <>
                    <FormInputLabel>Available From</FormInputLabel>
                    <FormInput
                      type="datetime-local"
                      value={this.state.editData.prebookingAvailabilityDate || ""}
                      onChange={(e) => {
                        let editData = this.state.editData;
                        // store ISO UTC for backend; keep UI control in local format
                        const localVal = e.target.value;
                        editData.prebookingAvailabilityDate = localVal;
                        this.setState({ editData });
                      }}
                    />
                    
                  </>
                )}
              </FormColumn>
              <FormColumn>
                <FormInputLabel>Number Format</FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  placeholder="RRSRRSBBB-BBSR (Red, Space, Black)"
                  value={this.state.editData.format}
                  onChange={(e) => {
                    if (e.target.value.length <= 15) {
                      this.handleChange(e.target, "", "format");
                    }
                  }}
                ></FormInput>
                <FormInputLabel
                  style={{
                    marginTop: "16px",
                  }}
                >
                  Status (sold/unsold)
                </FormInputLabel>
                <ReactSelect
                  placeholder={"Select Sold/Unsold"}
                  inputValue={this.state.soldUnsoldEditInput}
                  onInputChange={this.handleSoldUnsoldEditInputChange}
                  options={this.state.soldUnsoldEditOptions}
                  value={
                    this.state.editData.status
                      ? {
                          value: this.state.editData.status,
                          label:
                            this.state.editData.status == 0
                              ? "deleted"
                              : this.state.editData.status == 1
                              ? "sold"
                              : this.state.editData.status == 2
                              ? "unsold"
                              : false,
                        }
                      : false
                  }
                  stateEditName={"status"}
                  onChange={this.handleChange}
                  isMulti={false}
                />
                {this.state.editData ? (
                  this.state.editData.status !== undefined ? (
                    this.state.editData.status === 1 ? (
                      <React.Fragment>
                        <FormInputLabel
                          style={{
                            marginTop: "16px",
                          }}
                        >
                          Buyer-Id
                        </FormInputLabel>
                        <FormInput
                          type="text"
                          required={true}
                          value={this.state.editData.buyerId}
                          placeholder="Buyer Id"
                          onChange={(e) => {
                            this.handleChange(e.target, "", "buyerId");
                          }}
                        ></FormInput>
                      </React.Fragment>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                <div style={{ marginTop: "14px" }}>
                  <FormInputLabel>Badge</FormInputLabel>
                </div>
                <ReactSelect
                  placeholder={"Search Badge"}
                  inputValue={this.state.badgeEditInput}
                  onInputChange={this.handleBadgeEditInputChange}
                  options={this.state.badgeEditOptions}
                  value={
                    this.state.editData.badgeName
                      ? {
                          value: this.state.editData.badgeName[0],
                          label: this.state.editData.badgeName[0],
                        }
                      : false
                  }
                  stateEditName={"badgeName"}
                  onChange={(e) => {
                    this.handleChange(e, "", "badgeName");
                    this.setState({ badgeEditInput: "" });
                  }}
                  isLoading={this.state.badgeEditLoading}
                  isMulti={false}
                />
              </FormColumn>
            </FormRow>
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/numbers"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ editModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/numbers"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitEditForm(this.state.editData);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>

        {/* DELETE MODEL */}
        <Model title={"Delete Number"} modelOpen={this.state.deleteModelOpen}>
          <Form>
            <SubHeading>
              Are you sure, do you want to delete {this.state.deleteData.number}{" "}
              numbers data ?
            </SubHeading>
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/numbers"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ deleteModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/numbers"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitDeleteForm(this.state.deleteData);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>

        {/* CREATE MODEL */}
        <Model title={"Create Number"} modelOpen={this.state.createModelOpen}>
          <Form>
            <div style={{ background: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: "8px", padding: "10px 12px", color: "#000040", fontWeight: 700, fontSize: "13px", marginBottom: "12px" }}>Add New Number</div>
            <FormRow
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <ToggleButtonGroup
                color="success"
                value={this.state.createToggleSelector}
                exclusive={"singleSelect"}
                onChange={this.handleCreateToggleChnage}
                aria-label="Platform"
                sx={{
                  height: "25px",
                  margin: "10px",
                }}
              >
                <ToggleButton value="singleCreate">singleCreate</ToggleButton>
                <ToggleButton value="bulkCreate">bulkCreate</ToggleButton>
              </ToggleButtonGroup>
            </FormRow>
            {this.state.createToggleSelector === "singleCreate" ? (
              <FormRow
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  columnGap: "20px",
                }}
              >
                <FormColumn>
                  <FormInputLabel>Number</FormInputLabel>
                  <FormInput
                    type="text"
                    required={true}
                    placeholder="Number"
                    value={this.state.createData.number}
                    onChange={(e) => {
                      if (e.target.value.length <= 10) {
                        this.handleChange(e.target, "", "", "number");
                      }
                    }}
                  ></FormInput>
                  <FormInputLabel>Price</FormInputLabel>
                  <FormInput
                    type="text"
                    required={true}
                    value={this.state.createData.price}
                    placeholder="1000/-"
                    onChange={(e) => {
                      this.handleChange(e.target, "", "", "price");
                    }}
                  ></FormInput>
                  <FormInputLabel>Discount</FormInputLabel>
                  <FormInput
                    type="number"
                    required={true}
                    placeholder="50%"
                    min={0}
                    max={100}
                    value={this.state.createData.discount}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value !== "") {
                        value = Number(value);

                        // Ensure the value is between 0 and 100
                        if (value < 0) value = 0;
                        if (value > 100) value = 100;
                      }
                      this.handleChange({ value }, "", "", "discount");
                    }}
                  ></FormInput>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                    <FormInputLabel style={{ margin: 0 }}>Pre-Booking</FormInputLabel>
                    <Switch
                      checked={this.state.createData.isAvailableForPrebooking === true}
                      onChange={(e) => {
                        let createData = this.state.createData;
                        createData.isAvailableForPrebooking = e.target.checked;
                        this.setState({ createData });
                      }}
                    />
                  </div>
                  {this.state.createData.isAvailableForPrebooking && (
                    <>
                      <FormInputLabel>Available From</FormInputLabel>
                      <FormInput
                        type="datetime-local"
                        value={this.state.createData.prebookingAvailabilityDate || ""}
                        onChange={(e) => {
                          let createData = this.state.createData;
                          createData.prebookingAvailabilityDate = e.target.value;
                          this.setState({ createData });
                        }}
                      />
                    </>
                  )}
                </FormColumn>
                <FormColumn>
                  <FormInputLabel>Number Format</FormInputLabel>
                  <FormInput
                    type="text"
                    required={true}
                    placeholder="RRSRRSBBB-BBSR (Red, Space, Black)"
                    value={this.state.createData.format}
                    onChange={(e) => {
                      if (e.target.value.length <= 15) {
                        this.handleChange(e.target, "", "", "format");
                      }
                    }}
                  ></FormInput>
                  <div style={{ marginBottom: "1px" }}>
                    <FormInputLabel>Category</FormInputLabel>
                  </div>
                  <ReactSelect
                    placeholder={"Search Category"}
                    inputValue={this.state.categoryCreateInput}
                    onInputChange={this.handleCategoryCreateInputChange}
                    options={this.state.categoryCreateOptions}
                    onChange={(e) => {
                      this.handleChange(e, "", "", "categoryName");
                      this.setState({ categoryCreateInput: "" });
                    }}
                    isLoading={this.state.categoryCreateLoading}
                    isMulti={false}
                  />
                  <div style={{ marginTop: "22px" }}>
                    <FormInputLabel>Badge</FormInputLabel>
                  </div>
                  <ReactSelect
                    placeholder={"Search Badge"}
                    inputValue={this.state.badgeCreateInput}
                    onInputChange={this.handleBadgeCreateInputChange}
                    options={this.state.badgeCreateOptions}
                    onChange={(e) => {
                      this.handleChange(e, "", "", "badgeName");
                      this.setState({ badgeCreateInput: "" });
                    }}
                    isLoading={this.state.badgeCreateLoading}
                    isMulti={false}
                  />
                </FormColumn>
              </FormRow>
            ) : (
              <FormColumn>
                <Upload uploadResults={this.uploadResults} />
                <a
                  href="#"
                  onClick={() => {
                    downloadCsv({
                      arrayOfObj: [
                        {
                          number: "enter uniue 10 digit number",
                          price: "enter price in numbers",
                          categoryName:
                            "enter categoryName which exists in system",
                          badgeName: "enter badgeName which exists in system (Optional)",
                          discount: "enter discount in numbers (Optional)",
                        },
                        {
                          number: "example-1: 1112233444",
                          price: "example-1: 7999",
                          categoryName: "example-1: AAA-BBCC-DDDD",
                          badgeName: "example-1: Numerology",
                          discount: "example-1: 10",
                        },
                        {
                          number: "example-2: 9998887776",
                          price: "example-2: 12999",
                          categoryName: "example-2: PENTA NUMBER",
                          badgeName: "example-2: High Value",
                          discount: "example-2: 0, for no discount",
                        },
                      ],
                      fileName: "numbersBulkUpload.csv",
                    });
                  }}
                >
                  Download Sample CSV
                </a>
              </FormColumn>
            )}

            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/numbers"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ createModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/numbers"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitCreateForm(this.state.createData);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>
        {this.state.pleaseWaitLoading ? (
          <PleaseWait
            position={"fixed"}
            width={"100%"}
            height={"100%"}
            top={0}
            left={0}
            heading={this.state.pleaseWaitHeader}
          />
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Numbers);
